import React from 'react';
import { Link } from 'react-router-dom';

const Cover404 = () => {
  return (
    <React.Fragment>
      <div className='auth-page-content'>
        <div className='auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100'>
          <div className='auth-page-content overflow-hidden p-0'>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-12'>
                  <div className='text-center'>
                    <div className='mt-3'>
                      <h3 className='text-uppercase'>Sorry, Page not Found 😭</h3>
                      <p className='text-muted mb-4'>The page you are looking for not available!</p>
                      <Link to='/' className='btn btn-success'>
                        <i className='mdi mdi-home me-1'></i>Back to home
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Cover404;
